import axios from 'axios'
// import banner from '../../static/data/banner.json'
// import activity from '../../static/data/activity.json'

export default {
    getLines: function (success, error) {
        axios.get('/static/lines.json?v='+(new Date()).getTime()).then(response => {
            success(response)
        })
    },
    getBanner: function (success, error) {
        //1、ajax
        axios.get('/static/banner.json?v='+(new Date()).getTime()).then(response => {
            success(response)
        })

        //2、js引入
        // success({
        //     data: banner
        // })
    },
    getActivity: function (success, error) {
        //1、ajax
        axios.get('/static/activity.json?v='+(new Date()).getTime()).then(response => {
            success(response)
        })

        //2、js引入
        // success({
        //     data: activity
        // })
    },
    getAdult: function (success, error) {
        axios.get('/static/adult.json?v='+(new Date()).getTime()).then(response => {
            success(response)
        })
    }
}


// WEBPACK FOOTER //
// ./src/axios/index.js